module.exports = __webpack_public_path__ + "img/Abdallah.9601726a.jpg";